<ng-container *ngIf="isNewVersion; else legacy">
  <cigna-leaf-button
    variant="secondary"
    (click)="labelClick.emit()"
    [neutral]="true"
    data-test-id="filter-label-button"
    [text]="newFilterLabel"
    [svg]="caretDownIcon"
    iconPosition="after"
  >
  </cigna-leaf-button>
</ng-container>
<ng-template #legacy>
  <div class="filter-header" data-test-id="filter-label">
    <strong>{{ filterName }}</strong>
    <button
      (click)="labelClick.emit()"
      cignaButton="link"
      style="padding: 0 0.5em"
      data-test-id="filter-label-button"
      [title]="selectionText"
    >
      <span data-test-id="filter-label-text">{{ selectionText }}</span>
      <cigna-icon class="cg-margin-left-xs" type="caret-down"></cigna-icon>
    </button>
  </div>
</ng-template>
